import "./SelectField.scss";

import { MenuItem } from "@material-ui/core";
import React from "react";

import { Mode } from "../../../utils/utility";
import { FilledTextFieldProps, OutlinedTextFieldProps, StandardTextFieldProps, TextField } from "./TextField";

interface BaseSelectFieldProps {
  options: Array<any>;
}

export interface StandardSelectFieldProps extends StandardTextFieldProps, BaseSelectFieldProps { }
export interface FilledSelectFieldProps extends FilledTextFieldProps, BaseSelectFieldProps { }
export interface OutlinedSelectFieldProps extends OutlinedTextFieldProps, BaseSelectFieldProps { }

export type SelectFieldProps = StandardSelectFieldProps | FilledSelectFieldProps | OutlinedSelectFieldProps;

export const SelectField = (props: SelectFieldProps) => {
  // Props
  const {
    disabled,
    options,
  } = props;

  // Options
  const optionClass = "common-select-option" + (disabled ? "--disabled" : "");

  return (
    <TextField {...props} select autoComplete="new-password">
      {options.map((option: any) => {
        return (
          <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
            <div className={optionClass}>{option.label}</div>
          </MenuItem>
        );
      })}
    </TextField>
  );
};

SelectField.defaultProps = {
  mode: Mode.Edit,
  variant: "outlined",
}
